/*
 * Citera — product.js
 * Product-page-only behavior: variant selection + media gallery, gift-card
 * recipient, sticky add-to-cart, buy now, recommendations, recently-viewed
 * recording. Loaded (deferred) by sections/product.liquid ONLY, so other
 * templates never pay for it. Shared cart/dialog plumbing comes from global.js
 * via window.Citera.
 */
(function () {
  "use strict";
  if (!document.querySelector("[data-product]")) return;
  var C = window.Citera || {};
  var strings = C.strings || {};
  var announce = C.announce || function () {};
  var openDialog = C.openDialog || function () {};
  var postCart = C.postCart;
  var formToItem = C.formToItem;
  var canPurchaseForm = C.canPurchaseForm || function (form) { return !!form && form.dataset.velaPurchaseReady !== "false"; };
  var showCartError = C.showCartError || function () {};
  var clearCartError = C.clearCartError || function () {};
  var refreshCartDrawer = C.refreshCartDrawer || function () {};
  var CART_DRAWER_ID = C.cartDrawerId || "cart-drawer";

  /* ---------- Product: variant selection + media gallery ---------- */
  function variantData(product) {
    var script = product.querySelector("[data-variant-data]");
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function updateVariant(product, changedControl) {
    var controls = product.querySelectorAll("[data-option-index]");
    if (!controls.length) return;
    var chosen = Array.prototype.map.call(controls, function (el) {
      if (el.tagName === "SELECT") return el.value;
      var checked = el.querySelector("input:checked");
      return checked ? checked.value : "";
    });
    var variants = variantData(product);
    var match = variants.find(function (variant) {
      return variant.options.every(function (value, i) {
        return value === chosen[i];
      });
    });

    // A colour can have different sizes. Keep an exact combination when it
    // exists; otherwise choose a real variant of the newly selected colour.
    // Stock and price must not prevent viewing a colour or its photograph.
    if (!match && changedControl && changedControl.classList.contains("product__swatches")) {
      var changedIndex = Number(changedControl.dataset.optionIndex);
      match = variants.find(function (variant) {
        return variant.options[changedIndex] === chosen[changedIndex];
      });
      if (match) {
        chosen = match.options.slice();
        controls.forEach(function (control, i) {
          if (control.tagName === "SELECT") control.value = chosen[i];
          else control.querySelectorAll("input").forEach(function (input) {
            input.checked = input.value === chosen[i];
          });
        });
      }
    }

    controls.forEach(function (control, i) {
      if (control.classList.contains("vf-sizes")) {
        control.querySelectorAll("input").forEach(function (input) {
          var exists = variants.some(function (variant) {
            return variant.options.every(function (value, optionIndex) {
              return value === (optionIndex === i ? input.value : chosen[optionIndex]);
            });
          });
          input.disabled = !exists;
          input.setAttribute("aria-disabled", String(!exists));
        });
      }
      if (control.classList.contains("product__swatches")) {
        control.querySelectorAll(".product__swatch").forEach(function (labelEl) {
          var input = labelEl.querySelector("input");
          labelEl.classList.toggle("is-selected", !!(input && input.checked));
        });
        var checked = control.querySelector("input:checked");
        var out = control.parentElement.querySelector("[data-swatch-selected]");
        if (out && checked) out.textContent = checked.value;
      }
    });

    var idInput = product.querySelector("[data-variant-id]");
    var priceEls = product.querySelectorAll("[data-price]");
    var cardPriceEls = product.querySelectorAll("[data-card-price]");
    var skuEls = product.querySelectorAll("[data-product-sku]");
    var button = product.querySelector("[data-add-button]");
    var label = product.querySelector("[data-add-label]");

    if (idInput) idInput.value = match ? match.id : "";
    if (match) {
      skuEls.forEach(function (skuEl) {
        skuEl.textContent = match.sku || "";
      });
    }

    // Swap the gallery to the selected variant's image (variant/swatch gallery).
    if (match && match.featured_media_id) {
      var mediaThumb = product.querySelector('[data-media-id="' + match.featured_media_id + '"]');
      if (mediaThumb) activateThumb(product, mediaThumb);
    }

    priceEls.forEach(function (priceEl) {
      if (match && match.on_sale) {
        priceEl.innerHTML =
          '<span class="product__price-sale">' +
          match.price +
          '</span> <s class="product__price-compare">' +
          match.compare_at_price +
          "</s>";
      } else if (match) {
        priceEl.textContent = match.price;
      }
    });
    cardPriceEls.forEach(function (cardPriceEl) {
      if (match && match.card_price) cardPriceEl.textContent = match.card_price;
    });

    // Unit price (e.g. "$0.50/100ml") follows the selected variant.
    var unitPriceEl = product.querySelector("[data-unit-price]");
    if (unitPriceEl && match) {
      if (match.unit_price) {
        var valueEl = unitPriceEl.querySelector("[data-unit-price-value]");
        var baseEl = unitPriceEl.querySelector("[data-unit-price-base]");
        if (valueEl) valueEl.textContent = match.unit_price;
        if (baseEl) baseEl.textContent = (match.unit_price_base || "").replace(/^1\s+/, "");
        unitPriceEl.hidden = false;
      } else {
        unitPriceEl.hidden = true;
      }
    }

    var available = !!(match && match.available && match.price_ready);
    var pending = !!(match && !match.price_ready);
    var form = product.querySelector("form[data-cart-form]");
    if (form) form.dataset.velaPurchaseReady = String(available);
    product.querySelectorAll("[data-add-button], [data-sticky-add], [data-buy-now]").forEach(function (control) {
      control.disabled = !available;
      control.setAttribute("aria-disabled", String(!available));
      if (control.matches("[data-sticky-add]")) control.textContent = pending ? "Indisponibil momentan" : (available ? control.dataset.add : control.dataset.soldout);
    });
    if (button && label) label.textContent = pending ? label.dataset.pending : (available ? label.dataset.add : label.dataset.soldout);
    product.querySelectorAll("[data-vela-price-details]").forEach(function (details) { details.hidden = !match || !match.price_ready; });
    product.querySelectorAll("[data-vela-tu-note]").forEach(function (note) {
      var checked = note.parentElement.querySelector("input:checked");
      note.hidden = !checked || checked.value.toUpperCase() !== "TU";
    });
    if (form) clearCartError(form);

    // Rebuild the subscription plan list for the selected variant (plans + prices
    // are per-variant). Preserves the current one-time/subscribe choice.
    var planSelect = product.querySelector("[data-selling-plan]");
    if (planSelect && match) {
      var plans = match.selling_plans || [];
      var previous = planSelect.value;
      planSelect.innerHTML = plans
        .map(function (p) {
          return (
            '<option value="' + p.id + '">' + p.name + " — " + p.price + "</option>"
          );
        })
        .join("");
      if (previous) planSelect.value = previous;
      var subActive = product.querySelector("[data-purchase-subscription]");
      var isSub = subActive && subActive.checked;
      planSelect.hidden = !isSub || !plans.length;
      planSelect.disabled = !isSub || !plans.length;
    }

    if (!match) return;

    // Keep the URL shareable: reflect the chosen variant in ?variant= so reload,
    // back/forward, and copied links restore this selection.
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", match.id);
      window.history.replaceState({}, "", url);
    } catch (e) {
      /* very old browsers: skip URL sync */
    }

    // Sticky buy bar thumbnail follows the variant image.
    var stickyImg = product.querySelector(".product__sticky-img");
    if (stickyImg && match.featured_image) {
      stickyImg.src = match.featured_image;
      stickyImg.removeAttribute("srcset");
    }

    // Pickup availability is rendered server-side per variant — refetch it via
    // the Section Rendering API so locations/stock match the new selection.
    var pickupWrap = product.querySelector("[data-pickup-availability]");
    if (pickupWrap) {
      if (pickupController) pickupController.abort();
      pickupController = new AbortController();
      fetch(
        window.location.pathname +
          "?variant=" +
          match.id +
          "&section_id=pickup-availability",
        { signal: pickupController.signal }
      )
        .then(function (r) {
          return r.ok ? r.text() : "";
        })
        .then(function (html) {
          if (!html) return;
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var fresh = tmp.querySelector("[data-pickup-root]");
          if (fresh) pickupWrap.innerHTML = fresh.innerHTML;
        })
        .catch(function () {
          /* aborted or offline: keep the current pickup info */
        });
    }
  }
  var pickupController = null;

  // Purchase options: toggle the subscription plan select on/off. When one-time is
  // chosen the select is disabled so `selling_plan` is not submitted at all.
  document.addEventListener("change", function (event) {
    if (!event.target.closest("[data-purchase-options]")) return;
    if (event.target.name !== "purchase_option") return;
    var fieldset = event.target.closest("[data-purchase-options]");
    var planSelect = fieldset.querySelector("[data-selling-plan]");
    if (!planSelect) return;
    var isSub = event.target.value === "subscription";
    var hasPlans = planSelect.options.length > 0;
    planSelect.hidden = !isSub || !hasPlans;
    planSelect.disabled = !isSub || !hasPlans;
  });

  // Country / language selectors submit their localization form on change.
  document.addEventListener("change", function (event) {
    var loc = event.target.closest("[data-localization-select]");
    if (loc && loc.form) {
      loc.form.submit();
      return;
    }
  });

  // Gift-card recipient: reveal the fields + set the "send to recipient" flag.
  document.addEventListener("change", function (event) {
    var toggle = event.target.closest("[data-gift-toggle]");
    if (!toggle) return;
    var wrap = toggle.closest("[data-gift-recipient]");
    if (!wrap) return;
    var fields = wrap.querySelector("[data-gift-fields]");
    var flag = wrap.querySelector("[data-gift-enabled]");
    if (fields) {
      fields.hidden = !toggle.checked;
      // Disabled inputs don't submit — so unchecking clears any typed recipient
      // properties from the add-to-cart payload.
      fields.querySelectorAll("input:not([data-gift-enabled]), textarea").forEach(function (el) {
        el.disabled = !toggle.checked;
      });
    }
    if (flag) flag.value = toggle.checked ? "on" : "";
  });

  // Gift-card recipient: fill the timezone offset Shopify needs for scheduled
  // ("Send on") delivery. Minutes, as Date#getTimezoneOffset reports.
  document.querySelectorAll("[data-gift-offset]").forEach(function (el) {
    el.value = new Date().getTimezoneOffset().toString();
  });

  document.addEventListener("change", function (event) {
    var control = event.target.closest("[data-option-index]");
    if (!control) return;
    var product = control.closest("[data-product]");
    if (!product) return;
    updateVariant(product, control);
  });

  function activateThumb(product, thumb) {
    var main = product && product.querySelector("[data-media-main]");
    if (!main || !thumb) return;
    main.src = thumb.getAttribute("data-full");
    main.srcset = thumb.getAttribute("data-srcset");
    var alt = thumb.getAttribute("data-alt");
    if (alt !== null) main.alt = alt;
    var focal = thumb.getAttribute("data-focal");
    main.style.objectPosition = focal ? focal : "";
    product.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.setAttribute("aria-pressed", t === thumb ? "true" : "false");
    });
  }

  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-thumb]");
    if (!thumb) return;
    activateThumb(thumb.closest("[data-product]"), thumb);
  });

  /* ---------- Touch navigation for the product gallery and enlarged image ---------- */
  function bindMediaSwipe(surface, navigate) {
    if (!surface) return;
    var gesture = null;
    var suppressClickUntil = 0;
    surface.addEventListener("touchstart", function (event) {
      suppressClickUntil = 0;
      gesture = null;
      // Leave pinch zoom and an already magnified page to the browser.
      if (event.touches.length !== 1 || (window.visualViewport && window.visualViewport.scale > 1)) return;
      var touch = event.touches[0];
      gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, horizontal: false };
    }, { passive: true });
    surface.addEventListener("touchmove", function (event) {
      if (!gesture) return;
      if (event.touches.length !== 1) { gesture = null; return; }
      var touch = event.touches[0];
      var dx = Math.abs(touch.clientX - gesture.x);
      var dy = Math.abs(touch.clientY - gesture.y);
      if (!gesture.horizontal) {
        // A vertical gesture keeps scrolling the page, even if it later curves.
        if (dy > 10 && dy >= dx) { gesture = null; return; }
        if (dx > 10 && dx > dy * 1.25) gesture.horizontal = true;
      }
      if (gesture.horizontal && event.cancelable) event.preventDefault();
    }, { passive: false });
    surface.addEventListener("touchend", function (event) {
      var start = gesture;
      gesture = null;
      if (!start || event.touches.length) return;
      var touch = Array.from(event.changedTouches).find(function (item) { return item.identifier === start.id; });
      if (!touch) return;
      var dx = touch.clientX - start.x;
      var dy = touch.clientY - start.y;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
      if (event.cancelable) event.preventDefault();
      suppressClickUntil = Date.now() + 500;
      navigate(dx < 0 ? 1 : -1);
    }, { passive: false });
    surface.addEventListener("touchcancel", function () { gesture = null; }, { passive: true });
    // A completed swipe must not also activate the image's zoom button.
    surface.addEventListener("click", function (event) {
      if (event.detail === 0 || Date.now() > suppressClickUntil) return;
      suppressClickUntil = 0;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  document.querySelectorAll("[data-product]").forEach(function (product) {
    var thumbs = Array.from(product.querySelectorAll("[data-thumb]"));
    if (thumbs.length < 2) return;
    function navigateMedia(direction) {
      var active = thumbs.findIndex(function (thumb) { return thumb.getAttribute("aria-pressed") === "true"; });
      var next = thumbs[(Math.max(0, active) + direction + thumbs.length) % thumbs.length];
      activateThumb(product, next);
    }
    bindMediaSwipe(product.querySelector("[data-zoom-open]"), navigateMedia);
    var mainFrame = product.querySelector(".product__media-main");
    [-1, 1].forEach(function (direction) {
      if (!mainFrame) return;
      var button = document.createElement("button");
      button.type = "button";
      button.className = "vela-gallery-arrow vela-gallery-arrow--" + (direction < 0 ? "prev" : "next");
      button.setAttribute("aria-label", direction < 0 ? "Imaginea anterioară" : "Imaginea următoare");
      var mainImage = product.querySelector("[data-media-main]");
      if (mainImage && mainImage.id) button.setAttribute("aria-controls", mainImage.id);
      button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (direction < 0 ? "M15 6l-6 6 6 6" : "M9 6l6 6-6 6") + '"></path></svg>';
      button.addEventListener("click", function () { navigateMedia(direction); });
      mainFrame.appendChild(button);
    });
    var lightbox = product.querySelector("[data-lightbox]");
    if (!lightbox) return;
    bindMediaSwipe(lightbox.querySelector("[data-lightbox-img]"), function (direction) {
      var button = lightbox.querySelector(direction > 0 ? "[data-lightbox-next]" : "[data-lightbox-prev]");
      if (button) button.click();
    });
  });

  /* ---------- Sticky add-to-cart: show when the main buy button scrolls away, hide over the footer ---------- */
  document.querySelectorAll("[data-product]").forEach(function (product) {
    var sticky = product.querySelector("[data-sticky-atc]");
    var anchor = product.querySelector("[data-add-button]");
    if (!sticky || !anchor || !("IntersectionObserver" in window)) return;
    var footer = document.querySelector(".footer");
    var pastAnchor = false;
    var footerVisible = false;
    function update() {
      sticky.classList.toggle("is-visible", pastAnchor && !footerVisible);
    }
    new IntersectionObserver(
      function (entries) {
        // Show only once the buy button has been scrolled PAST (above the
        // viewport) — not while it still sits below, unseen, on page load.
        var entry = entries[0];
        pastAnchor = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      },
      { rootMargin: "0px 0px -80px 0px" },
    ).observe(anchor);
    if (footer) {
      new IntersectionObserver(
        function (entries) {
          footerVisible = entries[0].isIntersecting;
          update();
        },
        { rootMargin: "0px 0px 0px 0px" },
      ).observe(footer);
    }
  });

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-sticky-add]");
    if (!btn || btn.disabled) return;
    var product = btn.closest("[data-product]");
    var form = product && product.querySelector("form[data-cart-form]");
    if (!form || !canPurchaseForm(form)) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
  });

  // Buy now: add the item, then go straight to checkout.
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-buy-now]");
    if (!btn) return;
    if (btn.disabled) return;
    var product = btn.closest("[data-product]");
    var form = product && product.querySelector("form[data-cart-form]");
    if (!form || !canPurchaseForm(form)) return;
    event.preventDefault();
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    clearCartError(form);
    var fd = new FormData(form);
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [formToItem(fd)] }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && (data.status || data.description)) {
          btn.removeAttribute("aria-busy");
          btn.disabled = !canPurchaseForm(form);
          showCartError(form, data.description || data.message);
          return;
        }
        window.location.href = window.Shopify.routes.root + "checkout";
      })
      .catch(function () {
        btn.removeAttribute("aria-busy");
        btn.disabled = !canPurchaseForm(form);
        showCartError(form);
      });
  });

  /* ---------- Product recommendations (native Shopify API) ---------- */
  document.querySelectorAll("[data-product-recs]").forEach(function (el) {
    var url = el.getAttribute("data-url");
    if (!url) return;
    var load = function () {
      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, "text/html");
          var next = parsed.querySelector("[data-product-recs]");
          if (next) el.replaceWith(next);
        })
        .catch(function () {});
    };
    // Usually below the fold: fetch near the viewport, not at page load, so the
    // request doesn't compete with the page's critical resources.
    if ("IntersectionObserver" in window) {
      var recsIO = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          recsIO.disconnect();
          load();
        },
        { rootMargin: "600px 0px" }
      );
      recsIO.observe(el);
    } else {
      load();
    }
  });

  // Reconcile all controls on initial load, including direct ?variant= links.
  document.querySelectorAll("[data-product]").forEach(function (product) { updateVariant(product); });

  // Add all (frequently bought together): current product + all recommended single-variant items.
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-add-all]");
    if (!btn) return;
    var scope = btn.closest("[data-product-recs]") || document;
    var ids = [];
    scope.querySelectorAll("form[data-cart-form] [name='id']").forEach(function (input) {
      if (input.value && canPurchaseForm(input.closest("form[data-cart-form]"))) ids.push(input.value);
    });
    var main = document.querySelector("[data-product] [data-variant-id]");
    if (main && main.value && canPurchaseForm(main.closest("form[data-cart-form]"))) ids.unshift(main.value);
    if (!ids.length) return;
    if (btn.disabled) return;
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    postCart("cart/add.js", {
      items: ids.map(function (id) {
        return { id: id, quantity: 1 };
      }),
    })
      .then(function (data) {
        if (data && (data.status || data.description)) {
          announce(data.description || data.message || strings.cartError);
          return;
        }
        refreshCartDrawer(data.sections);
        openDialog(document.getElementById(CART_DRAWER_ID));
        announce(strings.cartAdded || "Produs adăugat în coș");
      })
      .catch(function () {
        announce(strings.cartError || "Coșul nu a putut fi actualizat");
      })
      .finally(function () {
        btn.removeAttribute("aria-busy");
        btn.disabled = false;
      });
  });


  /* ---------- Recently viewed: record the current product ---------- */
  var KEY = "citera:recent";
  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
    // Record the current product.
    var itemEl = document.querySelector("[data-recent-item]");
    if (itemEl) {
      try {
        var item = JSON.parse(itemEl.textContent);
        if (item && item.handle) {
          var list = readRecent().filter(function (p) {
            return p.handle !== item.handle;
          });
          list.unshift(item);
          localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
        }
      } catch (e) {}
    }

  /* ---------- Cookie-consent offset ----------
     Shopify's consent banner overlaps the fixed sticky buy bar on mobile.
     Measure the banner (injected late by the privacy API) and lift the bar by
     its height via --cookie-offset; falls back to 0 when absent/dismissed. */
  function applyCookieOffset(banner) {
    var visible = banner && banner.offsetParent !== null;
    document.documentElement.style.setProperty(
      "--cookie-offset",
      (visible ? Math.ceil(banner.getBoundingClientRect().height) : 0) + "px"
    );
  }
  function bindCookieBanner() {
    var banner = document.getElementById("shopify-pc__banner");
    if (!banner) return false;
    var apply = function () { applyCookieOffset(banner); };
    apply();
    if ("ResizeObserver" in window) new ResizeObserver(apply).observe(banner);
    new MutationObserver(apply).observe(banner, { attributes: true });
    return true;
  }
  if (!bindCookieBanner()) {
    var cookieMO = new MutationObserver(function () {
      if (bindCookieBanner()) cookieMO.disconnect();
    });
    cookieMO.observe(document.body, { childList: true, subtree: true });
    // No banner within 15s (consent not required in region) -> stop watching.
    setTimeout(function () { cookieMO.disconnect(); }, 15000);
  }
})();
